<nb-card>
  <nb-card-header>
    Filter
  </nb-card-header>
  <nb-card-body>
    <form [formGroup]="form">
      @if (mode() === 'overdue') {
        <wr-banner class="filter-hint"
                   status="basic"
                   [icon]="{ icon: 'info-outline', pack: 'eva' }"
                   message="Zuständigkeits-Filter gelten nur für &quot;Kommend&quot; – eine überfällige Begehung existiert noch nicht und hat daher noch keinen Zuständigen."></wr-banner>
      }
      @if (mode() === 'upcoming') {
        <div class="filter-control-group">
          <nb-checkbox formControlName="assignedToCurrentUser">Nur meine Begehungen</nb-checkbox>
        </div>
      }
      @if (mode() === 'overdue') {
        <div class="filter-control-group">
          <nb-checkbox formControlName="hideNeverInspected">Gebäude ohne bisherige Begehung ausblenden</nb-checkbox>
        </div>
      }
      <div class="filter-control-group">
        <label class="label" for="tenant">Hausverwaltung</label>
        <wr-tenant-select id="tenant"
                          formControlName="tenantId"
                          [tenantType]="TenantTypeEnum.External"
                          [showEmptyOption]="true"></wr-tenant-select>
      </div>
      <div class="filter-control-group">
        <label class="label" for="building">Gebäude</label>
        <wr-building-select id="building"
                            formControlName="building"
                            [tenantId$]="form.controls['tenantId'].valueChanges"></wr-building-select>
      </div>
      <div class="filter-control-group">
        <label class="label" for="regionSelect">Bereich</label>
        <wr-region-select id="regionSelect" formControlName="region"
                          [tenantId$]="form.controls['tenantId'].valueChanges"></wr-region-select>
      </div>
      <div class="filter-control-group">
        <label class="label" for="teamSelect">Team</label>
        <wr-team-select id="teamSelect" formControlName="team"
                        [tenantId$]="form.controls['tenantId'].valueChanges"
                        [regionId$]="regionId$"></wr-team-select>
      </div>
      @if (mode() === 'upcoming') {
        <div class="filter-control-group">
          <label class="label" for="technicianId">Techniker*in</label>
          <wr-user-select id="technicianId" formControlName="technician"></wr-user-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="clerkId">Sachbearbeiter*in</label>
          <wr-user-select id="clerkId" formControlName="clerk"></wr-user-select>
        </div>
      }
    </form>
  </nb-card-body>
</nb-card>
